import React, { useEffect, useState } from 'react'
import TopHeader from './TopHeader'
import AdvertiseBanner from './AdvertiseBanner'
import Categories from './Categories'
import LastMinutesDeal from './LastMinutesDeal'
import Products from './Products'
import DealOfDay from './DealOfDay'
import Facilities from './Facilities'
import NewsLetter from './NewsLetter'
import Footer from './Footer'
import Offers from './Offers'
import AllProducts from './AllProducts'
import axios from 'axios'
import { useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as HomeAction from '../../redux/actions/HomeAction'
import ProductsByBrand from './ProductsByBrand'

export default function Home() {

  const [time, setTime] = useState(new Date());
  const [save, setSave] = useState(false)
  const [show, setShow] = useState(false)
  const user_id = JSON.parse(localStorage.getItem('user'))
  const dispatch = useDispatch()
  const { products_by_brand } = bindActionCreators(HomeAction, dispatch)
  const [products, setProducts] = useState([])


  useEffect(() => {
    (async () => {
      const resData = await products_by_brand({
        user_id: user_id?.data?.id || null
      })
      console.log("resData", resData)
      if (resData?.statuscode == 200) {
        setProducts(resData?.data)
      }
    })()
  }, [save])

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setShow(true)
    }, 1000)
  }, [])



  return (
    <div>
      <TopHeader isUpdate={save} />
      <AdvertiseBanner />
      {/* {
        show && <>
          <Categories />
        </>
      } */}

      {/* <LastMinutesDeal /> */}
      <Products save={setSave} isUpdate={save} />
      {
        products?.map((data, index) => (

          <ProductsByBrand product={data} save={setSave} isUpdate={save} key={index} />
        ))
      }
      {/* <DealOfDay save={setSave} isUpdate={save} /> */}
      {/* <Offers save={setSave} isUpdate={save} /> */}
      {/* <AllProducts save={setSave} isUpdate={save} /> */}
      {/* <Facilities /> */}
      {/* <NewsLetter /> */}
      <Footer />
    </div>
  )
}
